import { DefaultDropdown } from "../../../../_helpers/components/Forms/Dropdown";
import { resolveExportColumnHeader } from "../../../../_api/ExportProfile";

const ONE_ROW_CALC_OPTIONS = [
    { value: "calc.name", label: "Nom du calcul" },
    { value: "calc.value", label: "Valeur" },
    { value: "calc.start_time", label: "Date début" },
    { value: "calc.end_time", label: "Date fin" },
    { value: "calc.payroll_rubric", label: "Rubrique paie" },
];

const EXPORT_OPTIONS = [
    { value: "export.start_date", label: "Début export" },
    { value: "export.end_date", label: "Fin export" },
];

const IconButton = ({ onClick, title, children, danger }) => (
    <button
        type="button"
        onClick={onClick}
        title={title}
        className={[
            "p-1 rounded border text-xs leading-none transition-colors",
            danger
                ? "border-red-200 text-red-600 hover:bg-red-50"
                : "border-gray-200 text-gray-600 hover:bg-gray-50",
        ].join(" ")}
    >
        {children}
    </button>
);

export const ExportColumnBuilder = ({
    columns,
    onChange,
    layoutMode,
    userFieldOptions,
    calculationNames,
}) => {
    const calcNamedOptions = calculationNames.map((name) => ({
        value: `calc.${name}`,
        label: name,
    }));

    const columnOptions =
        layoutMode === "one_row_per_record"
            ? [
                  { group: "Utilisateur", content: userFieldOptions },
                  { group: "Export", content: EXPORT_OPTIONS },
                  { group: "Calcul", content: ONE_ROW_CALC_OPTIONS },
              ]
            : [
                  { group: "Utilisateur", content: userFieldOptions },
                  { group: "Export", content: EXPORT_OPTIONS },
                  { group: "Calculs", content: calcNamedOptions },
              ];

    const moveColumn = (index, direction) => {
        const nextIndex = index + direction;
        if (nextIndex < 0 || nextIndex >= columns.length) return;

        const next = [...columns];
        [next[index], next[nextIndex]] = [next[nextIndex], next[index]];
        onChange(next.map((col, idx) => ({ ...col, position: idx + 1 })));
    };

    const updateColumnValue = (index, value) => {
        const column = columns[index];
        const previousSuggestion = resolveExportColumnHeader(column.value);
        const shouldRefreshHeader =
            !column.header || column.header === previousSuggestion;

        onChange(
            columns.map((col, idx) =>
                idx === index
                    ? {
                          ...col,
                          value,
                          header: shouldRefreshHeader
                              ? resolveExportColumnHeader(value)
                              : col.header,
                      }
                    : col
            )
        );
    };

    const updateColumnHeader = (index, header) => {
        onChange(columns.map((col, idx) => (idx === index ? { ...col, header } : col)));
    };

    const addColumn = () => {
        const value = userFieldOptions[0]?.value || "user.first_name";
        onChange([
            ...columns,
            {
                value,
                header: resolveExportColumnHeader(value),
                position: columns.length + 1,
            },
        ]);
    };

    const removeColumn = (index) => {
        onChange(
            columns
                .filter((_, i) => i !== index)
                .map((col, idx) => ({ ...col, position: idx + 1 }))
        );
    };

    return (
        <div className="space-y-2">
            <div className="overflow-x-auto rounded-lg border border-gray-200">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="bg-gray-50 text-left text-xs uppercase tracking-wide text-gray-500">
                            <th className="px-2 py-2 w-10 text-center">#</th>
                            <th className="px-2 py-2 min-w-[180px]">Donnée</th>
                            <th className="px-2 py-2 min-w-[120px]">Entête</th>
                            <th className="px-2 py-2 w-24 text-center">Ordre</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {columns.map((column, index) => (
                            <tr key={`${column.position}-${index}`} className="bg-white">
                                <td className="px-2 py-1.5 text-center text-gray-400 text-xs">
                                    {column.position}
                                </td>
                                <td className="px-2 py-1.5">
                                    <DefaultDropdown
                                        value={column.value}
                                        options={columnOptions}
                                        onChange={(e) => updateColumnValue(index, e.target.value)}
                                        className="[&_select]:py-1.5 [&_select]:text-sm"
                                    />
                                </td>
                                <td className="px-2 py-1.5">
                                    <input
                                        type="text"
                                        value={column.header || ""}
                                        onChange={(e) => updateColumnHeader(index, e.target.value)}
                                        placeholder="NOM"
                                        className="w-full text-sm border border-gray-200 rounded-md px-2 py-1.5 bg-gray-50 focus:bg-white focus:outline-none focus:border-gray-400"
                                    />
                                </td>
                                <td className="px-2 py-1.5">
                                    <div className="flex items-center justify-center gap-1">
                                        <IconButton
                                            onClick={() => moveColumn(index, -1)}
                                            title="Monter"
                                        >
                                            ↑
                                        </IconButton>
                                        <IconButton
                                            onClick={() => moveColumn(index, 1)}
                                            title="Descendre"
                                        >
                                            ↓
                                        </IconButton>
                                        {columns.length > 1 && (
                                            <IconButton
                                                onClick={() => removeColumn(index)}
                                                title="Supprimer"
                                                danger
                                            >
                                                ×
                                            </IconButton>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <button
                type="button"
                onClick={addColumn}
                className="text-sm text-app-primary hover:underline"
            >
                + Ajouter une colonne
            </button>
        </div>
    );
};
